(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["production-main-0a037d97"] = factory();
	else
		root["production-main-0a037d97"] = factory();
})(self, () => {
return 